import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
} from "@suraasa/placebo-ui"
import { ReactElement } from "react"

type Props = {
  title: string
  content: ReactElement
  isOpen: boolean
  onClose?: () => void
}

const Alert = ({ title, content, isOpen, onClose }: Props) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent>
        <DialogHeader hideClose>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Typography>{content}</Typography>
        </DialogBody>
        <DialogFooter>
          <Button onClick={onClose} color="black">
            Okay, I understand
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default Alert
